module.exports = __webpack_public_path__ + "static/media/TOY_1.546f001.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/TOY_1.mp4
// module id = DMOD
// module chunks = 1